import { Directive, OnInit, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { AuthenticationService } from './authentication.service';

@Directive({ selector: '[accessArea]'})
export class AccessAreaDirective implements OnInit {
    constructor(
        private templateRef: TemplateRef<any>,
        private authenticationService: AuthenticationService,
        private viewContainer: ViewContainerRef
    ) { }

    accessCodes: string[];

    @Input() 
    set accessArea(codes: string[]) {
        if (!codes || !codes.length) {
            throw new Error('Access area is empty or missed');
        }

        this.accessCodes = codes;
    }

    ngOnInit() {
        var user = this.authenticationService.User;
        var config = this.authenticationService.Config;

        let hasAccess = false;

        if (this.authenticationService.User && this.accessCodes) {
            //hasAccess = this.accessCodes.some(r => config.privileges(r));
            var privileges: any = config.privileges;
            var requiredAccessAreaCodes = this.accessCodes;  //multiple access area 

            if (privileges && requiredAccessAreaCodes) {
                for (var i = 0; i < requiredAccessAreaCodes.length; i++) { //123:SWR,124:WR,125:R,126
                    var tempAccess = requiredAccessAreaCodes[i].split(':');//123:SWR

                    var requiredAccessArea = tempAccess[0];//123
                    var requiredAccessType = tempAccess.length > 1 ? tempAccess[1] : 'R'; //SWR or default R

                    var assignedAccessType = privileges[requiredAccessArea]; //assigned privilege for example either S or W or R
                    if (assignedAccessType && requiredAccessType.indexOf(assignedAccessType) >= 0) {                       
                        hasAccess = true;
                        break;
                    }
                }
            }

        }

        if (hasAccess) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
